import React, { useEffect, useState } from 'react';
import Cookies from 'universal-cookie';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { NewUploadEnum } from '../../utils/enums';
import authorize from '../../utils/auth';
import AuthorizedResource from '../authorization/AuthorizedResource';
import DOCUMENTS_CONTROLLER from '../../controllers/documents';
import getClientConfig from '../../utils/getClientConfig';
import LanguageStringResolver from '../fields/language/LanguageStringResolver';
import '@avalara-raas/mapper-ui/webcomponent';

const initializeAccordionState = (cookies, setIsExpanded) => {
    const cookieState = cookies.get(NewUploadEnum.ACCORDION_STATE);
    if (cookieState !== undefined) {
        setIsExpanded(cookieState === NewUploadEnum.EXPANDED);
    } else {
        setIsExpanded(true);
        cookies.set(NewUploadEnum.ACCORDION_STATE, NewUploadEnum.EXPANDED);
    }
};

const handleAccordionToggle = (isExpanded, setIsExpanded, cookies) => {
    const newExpanded = !isExpanded;
    setIsExpanded(newExpanded);
    cookies.set(NewUploadEnum.ACCORDION_STATE, newExpanded ? NewUploadEnum.EXPANDED : NewUploadEnum.COLLAPSED);
};

const renderAccordionHeader = (isExpanded) => {
    const infoTrigger = <><LanguageStringResolver className="m15" string='uploadInformation' /><s-icon name="chevron-down"></s-icon></>;
    const infoTriggerOff = <><LanguageStringResolver className="m15" string='uploadInformation' /><s-icon name="chevron-up"></s-icon></>;
    return isExpanded ? infoTriggerOff : infoTrigger;
};

const renderAccordionContent = (enableClearingText) => (
    <div>
        <p className="small-font ml20">
            <LanguageStringResolver string='uploadFlowInfo' /><br />
            <LanguageStringResolver string='newFileNameRestrictions' />
            <code><LanguageStringResolver string='fileNameAllowedSpecialCharacters' /></code><br />
            <LanguageStringResolver string='newRightToUse' /><br />
            <LanguageStringResolver string='newDownloadGenericFullTemplateText' /><br />
            <a data-test="button-download-full-template" className="button secondary m15" href="/full-template.xls"><LanguageStringResolver string='downloadGenericFullTemplateBtn' /></a>
            <a data-test="button-download-gl-template" className="button secondary m15" href="/gldata-template.xls"><LanguageStringResolver string='downloadGenericGLTemplateBtn' /></a>
            {enableClearingText && <a data-test="button-download-ct-template" className="button secondary m15" href="/clearing-template.xls"><LanguageStringResolver string='downloadGenericCTTemplateBtn' /></a>}
        </p>
    </div>
);

const MapperUIWrapper = (props) => {
    const [isExpanded, setIsExpanded] = useState(false);
    const cookies = new Cookies();
    const enableClearingText = getClientConfig()?.featureFlags?.EnableClearingText;
    const enableUploadedDocumentsPage = getClientConfig()?.featureFlags?.EnableUploadedDocumentsPage;

    useEffect(() => {
        props.doLoadRdiTenantId();
        initializeAccordionState(cookies, setIsExpanded);
    }, []);

    const toggleAccordion = () => {
        handleAccordionToggle(isExpanded, setIsExpanded, cookies);
    };

    const accordionHeader = renderAccordionHeader(isExpanded);

    if (!props.rdiTenantId) {
        return null;
    }

    return (
        <>
            <div className="content-area">
                <div>
                    <hr className="ml20 mr35" />
                    <button className='accordion-button ml5' onClick={toggleAccordion}>
                        {accordionHeader}
                    </button>
                    {isExpanded && renderAccordionContent(enableClearingText)}
                    <hr className="ml20 mr35 mb0" />
                </div>
                <mapper-ui-component
                    tenant-id={props.rdiTenantId}
                    enable-vat-platform-processing={props.enableVatPlatformProcessing ? String(props.enableVatPlatformProcessing) : undefined}
                    class="mapper-ui-component"
                />
                {enableUploadedDocumentsPage
                    ? <Link data-test="button-uploaded-document" className="button secondary m15 mt4 ml35" to="/uploadedDocuments"><LanguageStringResolver string='importTransactions_viewAllUploaded' /></Link>
                    : <Link data-test="button-processed-document" className="button secondary m15 mt4 ml35" to="/ProcessedDocuments"><LanguageStringResolver string='importTransactions_viewAll' /></Link>
                }
            </div>
        </>
    );
};

function mapDispatchersToProps(dispatch) {
    return {
        doLoadRdiTenantId: () => {
            dispatch(DOCUMENTS_CONTROLLER.doLoadRdiTenantId());
        }
    };
}

function mapStateToProps(state) {
    return {
        rdiTenantId: state.documents?.rdiTenantId,
        enableVatPlatformProcessing: state.featureFlag?.data?.EnableVatPlatformProcessing
    };
}

export default authorize({
    name: 'MapperUIWrapper',
    resource: connect(mapStateToProps, mapDispatchersToProps)(MapperUIWrapper)
}, AuthorizedResource, {
    showNotAuthorized: true
});
